<template>
  <div class="cute-timeline-title">
    <span class="cute-timeline-title__others">
      <slot name="others"></slot>
    </span>
    <div class="cute-timeline-title__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimelineTitle'
}
</script>

<style scoped>
.cute-timeline-title {
  display: flex;
  align-items: center;
  font-weight: bold;
  padding: 6px 0 2px;
  gap: 6px;
  border-top: 1px solid #e0e0e0;
  margin-top: 4px;
}
.cute-timeline-title:first-child {
  border-top: none;
  margin-top: 0;
}
.cute-timeline-title__others {
  flex-shrink: 0;
}
.cute-timeline-title__content {
  flex: 1;
}
</style>
